import { Link, useParams } from 'react-router-dom'
import './TGPlusExperienceCenterDetails.scss'
import { FC, useEffect, useState } from 'react'
import experienceCenterService from 'Services/experienceCenterService'
import {
  experienceCenterType,
  ExperienceDocuments,
} from 'Pages/Frontend/Components/TGPlus/ExperienceCenter/ExperienceCenter'
import { BreadCrumb, HorizontalLoader, ModalWrapper } from 'Components'
import { formatString } from 'Helpers/formatString'
import Swal from 'sweetalert2'
import { TimeConverter } from 'Helpers/TimeConverter'

const TGPlusExperienceCenterDetails = () => {
  const { id } = useParams()
  const [centers, setCenters] = useState<experienceCenterType>()
  const [request, setRequest] = useState<boolean>(false)
  const [showMore, setShowMore] = useState<boolean>(true)
  const [show, setShow] = useState<boolean>(false)
  const [docUrl, setDocUrl] = useState<string>()

  const getExperience = async () => {
    setRequest(true)
    await experienceCenterService.single(id).then(
      (response) => {
        setRequest(false)
        console.log({ experienceCenterService: response.data.data })
        setCenters(response.data.data)
      },
      () => {
        setRequest(false)
      },
    )
  }
  useEffect(() => {
    getExperience()
  }, [id])

  const [showModal, setShowModal] = useState(false)
  const [showApprovalModal, setShowApprovalModal] = useState(false)
  const [rejectionReason, serRejectionReason] = useState<string>('')
  const [approvalReason, serApprovalReason] = useState<string>('')

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const toggleAprovalModal = () => {
    setShowApprovalModal((prevState) => !prevState)
  }

  const [approvalRequest, setApprovalRequest] = useState(false)

  const [rejectionRequest, setRejectionRequest] = useState(false)

  const reject = async () => {
    setRejectionRequest(true)
    if (!id) return
    await experienceCenterService.reject({ rejectionReason }, id).then(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Rejection Completed',
          showConfirmButton: false,
          timer: 2000,
        })

        setRejectionRequest(false)

        setTimeout(() => {
          getExperience()
          toggleModal()
        }, 1000)
      },
      (error: { response: { data: { error: string } } }) => {
        setRejectionRequest(false)
        console.log('update Subscription error', error)

        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const approve = async () => {
    setApprovalRequest(true)
    if (!id) return
    await experienceCenterService.approve({ approvalNotes: approvalReason }, id).then(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Approval Completed!',
          showConfirmButton: false,
          timer: 2000,
        })

        setApprovalRequest(false)

        setTimeout(() => {
          getExperience()
          toggleAprovalModal()
        }, 1000)
      },
      (error: { response: { data: { error: string } } }) => {
        setApprovalRequest(false)
        console.log('update Subscription error', error)

        toggleAprovalModal()
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const showDocument = (docUrl: string) => {
    setShow(true)
    setDocUrl(docUrl)
  }

  const [deactivating, setDeactivating] = useState(false)

  const decomissionCenter = async () => {
    if (!id) return
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'This will deactivate the experience center. This action can be undone by activating the center again.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Deactivate',
      cancelButtonText: 'Cancel',
    })
    if (!confirmation.isConfirmed) return
    setDeactivating(true)
    await experienceCenterService.decommision(id).then(
      () => {
        setDeactivating(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Decommision completed!',
          showConfirmButton: false,
          timer: 2000,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        setDeactivating(false)
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const [showActivationModal, setShowActivationModal] = useState(false)
  const toggleActivateCenterModal = () => {
    setShowActivationModal(!showActivationModal)
  }

  const [installationDate, setInstallationDate] = useState<string>('')
  const [updatingInstallationDate, setUpdatingInstallationDate] = useState(false)

  const activate = async () => {
    if (!id) return
    setUpdatingInstallationDate(true)
    await experienceCenterService.activate(id, { installationCompletedAt: installationDate }).then(
      () => {
        setUpdatingInstallationDate(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Activation completed!',
          showConfirmButton: false,
          timer: 2000,
        })
      },
      (error) => {
        setUpdatingInstallationDate(false)

        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const [mapRealSource, setMapRealSource] = useState<string>()

  useEffect(() => {
    if (centers && centers.stationAddress) {
      const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(centers?.stationAddress)}&output=embed`
      setMapRealSource(mapSrc)
    }
  }, [centers])

  return (
    <div className='TGPlusExperienceCenterDetails mb-4'>
      <div className='container'>
        <BreadCrumb
          title={'Experience Center Details'}
          parent={'Tradegrid Plus'}
          parentUrl={'tgplus-subscription'}
          showTitle={false}
        ></BreadCrumb>

        <div className='row'>
          <div className='col-md-6'>
            {' '}
            <div className='title'>
              <b>
                {centers?.customer.firstName} {centers?.customer.lastName}
              </b>{' '}
              <span
                className={
                  ['REJECTED', 'PENDING_APPROVAL'].includes(String(centers?.approvalStatus)) ===
                  true
                    ? 'status-unapproved'
                    : 'status-approved'
                }
              >
                {formatString(centers?.approvalStatus)}
              </span>
            </div>
          </div>
          {['PENDING_APPROVAL'].includes(String(centers?.approvalStatus)) === true ? (
            <div className='col-md-6 text-md-end'>
              <button className='btn btn-reject me-2' onClick={toggleModal}>
                Reject
              </button>
              <button className='btn btn-approve' onClick={toggleAprovalModal}>
                Approve
              </button>
            </div>
          ) : (
            <div className='col-md-6 text-md-end'>
              <button
                className='btn btn-reject me-2'
                onClick={decomissionCenter}
                disabled={deactivating}
              >
                Decommission{' '}
                {deactivating && <span className='spinner-border spinner-border-sm'></span>}
              </button>

              {centers?.approvalStatus != 'INSTALLATION_COMPLETED' && (
                <button className='btn btn-approve' onClick={toggleActivateCenterModal}>
                  Activate{' '}
                  {updatingInstallationDate && (
                    <span className='spinner-border spinner-border-sm'></span>
                  )}
                </button>
              )}
            </div>
          )}
        </div>

        <div className='row mt-4'>
          <div className='col-md-6'>
            <div className='sub-title'>Susbcription Summary</div>

            <div className='card border-0'>
              <div className='card-body'>
                {request && <HorizontalLoader></HorizontalLoader>}

                {!request && (
                  <div className='row'>
                    <div className='col-6 label'>Product Type</div>
                    <div className='col-6 text-end value'>{formatString(centers?.product)}</div>
                    <div className='col-6 label'>Daily Sales Volume</div>
                    <div className='col-6 text-end value'>{centers?.pumps}</div>
                    <div className='col-6 label'>Rentage</div>
                    <div className='col-6 text-end value'>{centers?.rentage}</div>
                    <div className='col-6 label'>Daily Sales Volume</div>
                    <div className='col-6 text-end value'>{centers?.dailySalesVolume}</div>
                    <div className='col-6 label'>Next Subscription Payment Due Date</div>
                    <div className='col-6 text-end value'>
                      {centers?.nextSubscriptionPaymentDueDate}
                    </div>

                    <div className='col-6 label'>Activation Date</div>
                    <div className='col-6 text-end value'>
                      {TimeConverter(
                        centers?.statusHistory?.find(
                          (stat: { status: string }) => stat.status === 'INSTALLATION_COMPLETED',
                        )?.dateTimeInISO8601,
                      )}
                    </div>

                    {/* <div className='col-6 label'>Montly Repayment</div>
                    <div className='col-6 text-end value'>5 Referrals</div>
                    <div className='col-6 label'>Next Due Date</div>
                    <div className='col-6 text-end value'>₦200,000.00</div>
                    <div className='col-6 label'>Tenure</div>
                    <div className='col-6 text-end value'>₦200,000.00</div> */}
                  </div>
                )}
              </div>
            </div>

            <div className='card mb-3 wallet border-0 mt-4'>
              <div className='card-body'>
                <div className='wallet-label'>Total Amount Earned</div>
                <div className='wallet-value'>₦0.00</div>
              </div>
            </div>

            {centers?.approvalNotes && (
              <>
                <div className='sub-title mt-4'>Approval Reason</div>

                <div className='card mb-3 wallet border-0 '>
                  <div className='card-body'>
                    <div className='wallet-label'>
                      <b className='me-4'></b>
                      {centers?.approvalNotes}
                    </div>
                  </div>
                </div>
              </>
            )}
            {centers?.rejectionReason && (
              <>
                <div className='sub-title mt-4'>Rejection Reason</div>

                <div className='card mb-3 wallet border-0 mt-4'>
                  <div className='card-body'>
                    <div className='wallet-label'>{centers?.rejectionReason}</div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className='col-md-6'>
            <div className='sub-title'>Station Details</div>

            <div className='card border-0'>
              <div className='card-body'>
                {request && <HorizontalLoader></HorizontalLoader>}

                {!request && (
                  <div className='row'>
                    <div className='col-6 label'>Station Name</div>
                    <div className='col-6 text-end value'>{centers?.stationName}</div>
                    <div className='col-6 label'>Address</div>
                    <div className='col-6 text-end value'>{centers?.stationAddress} </div>
                    <div className='col-6 label'>Station State</div>
                    <div className='col-6 text-end value'>{centers?.state}</div>
                  </div>
                )}

                <div className='text-center mt-4'>
                  <span
                    className={showMore ? 'view-more' : 'view-more close'}
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? 'View Less' : 'View More'}{' '}
                    <svg
                      width='18'
                      height='18'
                      viewBox='0 0 18 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.49749 6.68172C2.49749 6.53922 2.54999 6.39672 2.66249 6.28422C2.87999 6.06672 3.23999 6.06672 3.45749 6.28422L8.34749 11.1742C8.70749 11.5342 9.29249 11.5342 9.65249 11.1742L14.5425 6.28422C14.76 6.06672 15.12 6.06672 15.3375 6.28422C15.555 6.50172 15.555 6.86172 15.3375 7.07922L10.4475 11.9692C10.065 12.3517 9.54749 12.5692 8.99999 12.5692C8.45249 12.5692 7.93499 12.3592 7.55249 11.9692L2.66249 7.07922C2.55749 6.96672 2.49749 6.82422 2.49749 6.68172Z'
                        fill='#868484'
                      />
                    </svg>
                  </span>
                </div>

                {showMore && (
                  <>
                    {' '}
                    <ul className='nav nav-tabs' id='experienceCenterTab' role='tablist'>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link active'
                          id='ec-details-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#ec-details'
                          type='button'
                          role='tab'
                          aria-controls='ec-details'
                          aria-selected='true'
                        >
                          Details
                        </button>
                      </li>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link'
                          id='ec-docs-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#ec-docs'
                          type='button'
                          role='tab'
                          aria-controls='ec-docs'
                          aria-selected='false'
                        >
                          Documents
                        </button>
                      </li>
                    </ul>
                    <div className='tab-content mt-3' id='experienceCenterTabContent'>
                      <div
                        className='tab-pane fade show active'
                        id='ec-details'
                        role='tabpanel'
                        aria-labelledby='ec-details-tab'
                      >
                        {centers?.latitude === null && (
                          <div className='text-center mt-4' style={{ fontSize: '.8rem' }}>
                            No Cordinate found to display location
                          </div>
                        )}

                        {centers?.latitude && showMore && centers && (
                          <div style={{ position: 'relative' }} className='mt-3'>
                            <iframe
                              id='experience-center-map'
                              src={`https://www.google.com/maps?q=${centers.latitude},${centers.longitude}&z=15&output=embed`}
                              // src={mapRealSource}
                              width='100%'
                              height='300'
                              style={{ border: 0 }}
                              allowFullScreen={true}
                              allow='fullscreen'
                              loading='lazy'
                              referrerPolicy='no-referrer-when-downgrade'
                              className='p-0'
                              title='experience-center-small-map'
                            />
                            <button
                              type='button'
                              onClick={() => {
                                const overlayId = 'experience-center-map-overlay'
                                if (document.getElementById(overlayId)) return

                                const removeOverlay = (
                                  overlay: HTMLDivElement,
                                  escHandler: (e: KeyboardEvent) => void,
                                ) => {
                                  if (document.getElementById(overlayId)) {
                                    document.body.removeChild(overlay)
                                    document.removeEventListener('keydown', escHandler)
                                  }
                                }

                                const overlay = document.createElement('div') as HTMLDivElement
                                overlay.id = overlayId
                                Object.assign(overlay.style, {
                                  position: 'fixed',
                                  top: '0',
                                  left: '0',
                                  width: '100vw',
                                  height: '100vh',
                                  background: 'rgba(0,0,0,0.85)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: '2147483647',
                                })

                                const container = document.createElement('div') as HTMLDivElement
                                Object.assign(container.style, {
                                  width: '95%',
                                  height: '90%',
                                  maxWidth: '1200px',
                                  maxHeight: '900px',
                                  background: '#fff',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  position: 'relative',
                                })

                                const closeBtn = document.createElement('button')
                                closeBtn.innerText = 'Close'
                                Object.assign(closeBtn.style, {
                                  position: 'absolute',
                                  top: '10px',
                                  right: '10px',
                                  zIndex: '10',
                                  background: '#fff',
                                  border: '1px solid #ddd',
                                  padding: '6px 10px',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                })

                                const largeIframe = document.createElement('iframe')
                                // largeIframe.src = String(mapRealSource)
                                largeIframe.src = `https://www.google.com/maps?q=${centers.latitude},${centers.longitude}&z=15&output=embed`

                                largeIframe.style.width = '100%'
                                largeIframe.style.height = '100%'
                                largeIframe.style.border = '0'
                                largeIframe.allowFullscreen = true
                                largeIframe.setAttribute('loading', 'lazy')
                                largeIframe.setAttribute(
                                  'referrerpolicy',
                                  'no-referrer-when-downgrade',
                                )

                                container.appendChild(closeBtn)
                                container.appendChild(largeIframe)
                                overlay.appendChild(container)
                                document.body.appendChild(overlay)

                                const escHandler = (e: KeyboardEvent) => {
                                  if (e.key === 'Escape') removeOverlay(overlay, escHandler)
                                }

                                // close when clicking backdrop
                                overlay.addEventListener('click', (e) => {
                                  if (e.target === overlay) removeOverlay(overlay, escHandler)
                                })

                                closeBtn.addEventListener('click', () =>
                                  removeOverlay(overlay, escHandler),
                                )
                                document.addEventListener('keydown', escHandler)
                              }}
                              style={{
                                position: 'absolute',
                                right: '16px',
                                bottom: '16px',
                                zIndex: 2,
                                background: '#fff',
                                border: '1px solid #ddd',
                                padding: '6px 10px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '.8rem',
                              }}
                              className='btn btn-sm'
                            >
                              View large map
                            </button>
                          </div>
                        )}
                      </div>

                      <div
                        className='tab-pane fade'
                        id='ec-docs'
                        role='tabpanel'
                        aria-labelledby='ec-docs-tab'
                      >
                        {centers?.documents && centers.documents.length > 0 ? (
                          <ul className='list-unstyled mb-0'>
                            {(centers as any).documents.map(
                              (doc: ExperienceDocuments, idx: number) => (
                                <li
                                  key={idx}
                                  className='py-2 border-0 d-flex justify-content-between  document-list'
                                >
                                  <div>
                                    <svg
                                      width='20'
                                      height='20'
                                      viewBox='0 0 24 24'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                      className='me-2'
                                    >
                                      <path
                                        d='M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z'
                                        fill='#2ECC71'
                                      />
                                      <path
                                        d='M7.75 11.9999L10.58 14.8299L16.25 9.16992'
                                        stroke='white'
                                        strokeWidth='1.5'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                      />
                                    </svg>

                                    {formatString(doc.fileCategory)}
                                  </div>
                                  <a
                                    href={'#'}
                                    className='text-decoration-none'
                                    onClick={() => showDocument(doc.url)}
                                  >
                                    Review
                                  </a>
                                </li>
                              ),
                            )}
                          </ul>
                        ) : (
                          <div className='text-center py-3'>No documents found</div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className='col-md-12 mt-4'>
            <div className='row'>
              <div className='col-8 col-lg-6'>
                <div className='sub-title'>Payment History</div>
              </div>
              <div className='col-4 col-lg-6'>
                <div className='sub-title text-end'>
                  <Link to={''} className='see-all text-decoration-none'>
                    See all
                  </Link>
                </div>
              </div>
            </div>

            <div className='card mt-1 border-0'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table w-100' style={{ tableLayout: 'fixed' }}>
                    <thead>
                      <tr>
                        <th>Month</th>
                        <th>Method</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <tr>
                        <td>December</td>
                        <td>Bank Transfer</td>
                        <td>₦100,000.00</td>
                        <td>
                          <span className='status-unpaid'>Unpaid</span>
                        </td>
                        <td>24/09/2022</td>
                        <td>
                          <Link to={''} className='view'>
                            View
                          </Link>{' '}
                        </td>
                      </tr>

                      <tr>
                        <td>December</td>
                        <td>Bank Transfer</td>
                        <td>₦100,000.00</td>
                        <td>
                          <span className='status-paid'>Paid</span>
                        </td>
                        <td>24/09/2022</td>
                        <td>
                          <Link to={''} className='view'>
                            View
                          </Link>{' '}
                        </td>
                      </tr>

                      <tr>
                        <td>December</td>
                        <td>Bank Transfer</td>
                        <td>₦100,000.00</td>
                        <td>
                          <span className='status-paid'>Paid</span>
                        </td>
                        <td>24/09/2022</td>
                        <td>
                          <Link to={''} className='view'>
                            View
                          </Link>{' '}
                        </td>
                      </tr> */}

                      <tr>
                        <td colSpan={6} className='text-center py-5'>
                          No transaction found
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Reject Application'>
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Reason for Rejection</label>
            <textarea
              className='form-control'
              required={true}
              onChange={(e: { target: { value: string } }) => serRejectionReason(e.target.value)}
            />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={reject}
              disabled={rejectionRequest}
            >
              {rejectionRequest && <span className='spinner-border spinner-border-sm'></span>}{' '}
              Submit
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={showApprovalModal}
        closeModal={toggleAprovalModal}
        title='Approve Application'
      >
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Comment</label>
            <textarea
              required={true}
              className='form-control'
              onChange={(e: { target: { value: string } }) => serApprovalReason(e.target.value)}
            />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={approve}
              disabled={approvalRequest}
            >
              {approvalRequest && <span className='spinner-border spinner-border-sm'></span>} Submit
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={show}
        closeModal={() => setShow(false)}
        title='Review Photo'
        hideHeader={false}
        size='lg'
      >
        {docUrl &&
          (() => {
            const isVideo = /\.(mp4|webm|ogg|mov|avi|mkv)(\?.*)?$/i.test(docUrl)
            return isVideo ? (
              <video src={docUrl} className='w-100' controls>
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={docUrl} alt='' className='w-100' />
            )
          })()}

        {docUrl && (
          <a href={docUrl} download={true} target='_blank' rel='noreferrer'>
            <button className='btn mt-1'>
              <svg
                width='15'
                height='15'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='me-1'
              >
                <path
                  d='M6.75 13.3125C6.675 13.3125 6.6075 13.2975 6.5325 13.2675C6.3225 13.185 6.1875 12.975 6.1875 12.75V8.25C6.1875 7.9425 6.4425 7.6875 6.75 7.6875C7.0575 7.6875 7.3125 7.9425 7.3125 8.25V11.3925L7.8525 10.8525C8.07 10.635 8.43 10.635 8.6475 10.8525C8.865 11.07 8.865 11.43 8.6475 11.6475L7.1475 13.1475C7.0425 13.2525 6.8925 13.3125 6.75 13.3125Z'
                  fill='#000076'
                />
                <path
                  d='M6.75008 13.3126C6.60758 13.3126 6.46508 13.2601 6.35258 13.1476L4.85258 11.6476C4.63508 11.4301 4.63508 11.0701 4.85258 10.8526C5.07008 10.6351 5.43008 10.6351 5.64758 10.8526L7.14758 12.3526C7.36508 12.5701 7.36508 12.9301 7.14758 13.1476C7.03508 13.2601 6.89258 13.3126 6.75008 13.3126Z'
                  fill='#000076'
                />
                <path
                  d='M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H10.5C10.8075 0.9375 11.0625 1.1925 11.0625 1.5C11.0625 1.8075 10.8075 2.0625 10.5 2.0625H6.75C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V7.5C15.9375 7.1925 16.1925 6.9375 16.5 6.9375C16.8075 6.9375 17.0625 7.1925 17.0625 7.5V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625Z'
                  fill='#000076'
                />
                <path
                  d='M16.5 8.06335H13.5C10.935 8.06335 9.9375 7.06585 9.9375 4.50085V1.50085C9.9375 1.27585 10.0725 1.06585 10.2825 0.983346C10.4925 0.893346 10.7325 0.945846 10.8975 1.10335L16.8975 7.10335C17.055 7.26085 17.1075 7.50835 17.0175 7.71835C16.9275 7.92835 16.725 8.06335 16.5 8.06335ZM11.0625 2.85835V4.50085C11.0625 6.43585 11.565 6.93835 13.5 6.93835H15.1425L11.0625 2.85835Z'
                  fill='#000076'
                />
              </svg>
              Download
            </button>
          </a>
        )}
      </ModalWrapper>

      <ModalWrapper
        showModal={showActivationModal}
        closeModal={() => setShowActivationModal(false)}
        title='Activate Center'
      >
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Installation Date</label>
            <input
              type='date'
              required={true}
              className='form-control'
              onChange={(e: { target: { value: string } }) => setInstallationDate(e.target.value)}
            />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={activate}
              disabled={updatingInstallationDate}
            >
              {updatingInstallationDate && (
                <span className='spinner-border spinner-border-sm'></span>
              )}{' '}
              Submit
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default TGPlusExperienceCenterDetails
